module.exports = __webpack_public_path__ + "img/asmntprogactive.2dbb1fe2.svg";